export const itemsCompany = [
    { id: 1, label: "Personal" },
    { id: 2, label: "Daimler AG" },
    { id: 3, label: "Fortress Biotech" },
];

export const itemsType = [
    { id: 1, label: "Saving" },
    { id: 2, label: "Checking" },
    { id: 3, label: "Credit" },
]

export const itemsCurrency = [
  {id: 1, label: 'USD'},
  {id: 2, label: 'EURO'}
]